<template>
  <section id="photo-section" class="photo-section">
    <img src="../assets/images/photo_2025-10-10_10-27-43.jpg" alt="Gym Group Photo" class="photo-img">
  </section>
</template>

<script setup>
// No se necesita script
</script>

<style scoped>
.photo-section {
  position: relative;
  width: 100%;
  height: 700px; /* Ajusta según el tamaño del grupo */
  overflow: hidden;
}

.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ocupa todo el espacio */
  object-position: center top; /* Centra la parte importante de la foto (grupo) */
  transition: transform 0.5s ease;
}

/* Hover sutil */
.photo-img:hover {
  transform: scale(1.03);
}

/* Overlay opcional */
.photo-section::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.2);
  pointer-events: none;
}
</style>
